import { Component, OnInit, Input } from '@angular/core';
import { StandardFile } from '../../classes/file/file';
import { MatDialog } from '@angular/material/dialog';
import { ImageCropperComponent } from '../image-cropper/image-cropper.component';
import { FilesService } from '../../services/files/files.service';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
  providers: [FilesService]
})
export class ProfilePictureComponent implements OnInit {


  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form;
  @Input() controlName;
  @Input() disabled;
  @Input() maxLength;
  @Input() label_block;
  @Input() pattern;
  @Input() pattern_desc;
  @Input() minlength;
  @Input() maxValue;
  @Input() minValue;
  @Input() minLength;
  @Input() transform;
  @Input() data;
  @Input() prefix_label;
  @Input() suffix_label;
  @Input() label_class;
  image = "assets/user-profile.jpg";
  imageChangedEvent: any = '';
  selected_files = [];

  public active;
  constructor(
    private dialog: MatDialog,
    private file_service: FilesService,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.selected_files = this.form.get(this.controlName).value;
      this.image = this.selected_files && this.selected_files[0] && this.selected_files[0].file_path ? this.selected_files[0].file_path : (this.selected_files && this.selected_files[0] && this.selected_files[0].content ? this.selected_files[0].content : 'assets/user-profile.jpg')
    });
  }


  cropImage() {
    // const reader = new FileReader();
    // reader.readAsDataURL(document.getElementById('file-input')['files'][0]);
    // let file = document.getElementById('file-input')['files'];
    // let image_file = new StandardFile();
    const dialog = this.dialog.open(ImageCropperComponent, {
      disableClose: true
    });
    (dialog).componentInstance.image_src = this.selected_files;
    (dialog).componentInstance.aspectRatio = 1 / 1;
    (dialog).componentInstance.crop_flag = 1;
    dialog.afterClosed().subscribe(result => {
      if (result) {

        this.selected_files = result;
        this.form.get(this.controlName).patchValue(result);
        this.image = this.selected_files && this.selected_files[0] && this.selected_files[0].file_path ? this.selected_files[0].file_path : (this.selected_files && this.selected_files[0] && this.selected_files[0].content ? this.selected_files[0].content : 'assets/user-profile.jpg')

        // image_file.setFileDetails(file.name, file.type, result, file.name.split('.')[1], 1, 0, file.size, 1, null);
      }
    },
      err => {

      })
  }


  fileInputDropped(ev) {
    this.fileInputChanged(ev.dataTransfer.files);
  }

  fileInputChanged(event) {
    // const reader = new FileReader();
    // reader.readAsDataURL(document.getElementById('file-input')['files'][0]);
    let files = document.getElementById('file-input')['files'];
    // let image_file = new StandardFile();
    if (files && typeof files == 'object' && files.length) {
      this.imageChangedEvent = files;

      this.file_service.convertFilesToBase64(files).subscribe(res => {

        this.selected_files = res as any;
        this.cropImage();
      })
    }

    // this.imageChangedEvent = event;
    // this.cropImage();
  }

  selectFile() {

  }

}
